import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["customTypeSelect"];

  submit(event) {
    event.preventDefault();
    let form = document.querySelector("#new_cash_payment");
    const alert = document.getElementById("cash_payment_alert");
    if (window.location.href.includes("/edit")) {
      form = document.getElementsByClassName("edit_cash_payment")[0];
    }
    if (this.invalidInputs() > 0) {
      alert.classList.remove("d-none");
      this.scrollToTop();
      return 0;
    } else {
      alert.classList.add("d-none");
      form.submit();
    }
  }

  linkTransactions() {
    let transactions = document.getElementById("bank_transactions");
    if (transactions === null) {
      document.getElementById("no_np_transactions").classList.remove("d-none");
      this.scrollToTop();
      setTimeout(function() {
        location.reload();
      }, 2000);
      return 0;
    } else {
      transactions = transactions.classList;
    }
    const cashPaidAmount = document.getElementById("paid_amount");
    if (this.customTypeSelectTarget.value === "bank_transaction") {
      transactions.remove("d-none");
      cashPaidAmount.classList.add("d-none");
    } else {
      transactions.add("d-none");
      cashPaidAmount.classList.remove("d-none");
    }
  }

  calculateCustomFields(e) {
    const productPrice = document.getElementById("cash_payment_product_price");
    const totalWeight = document.getElementById("cash_payment_total_weight");
    const paidAmount = document.getElementById("cash_payment_paid_amount");
    const paidAmountWithoutComm = document.getElementById("cash_payment_paid_amount_without_commission");
    let floatPrice = parseFloat(productPrice.value);
    let floatWeight = parseFloat(totalWeight.value);
    let floatAmount = parseFloat(paidAmount.value);
    let totalSum = floatAmount;
    let freezeNnnPlusPercent = 0;
    if(paidAmountWithoutComm) {
      freezeNnnPlusPercent = parseFloat(paidAmountWithoutComm.dataset.nnnpluscomm);
      totalSum = parseFloat(paidAmountWithoutComm.value);
    }
    if (floatPrice && floatWeight > 0 && totalSum > 0) {
      if (e.target === productPrice) {
        totalWeight.value = (totalSum / floatPrice).toFixed(4);
      } else if (e.target === totalWeight || e.target === paidAmount) {
        productPrice.value = (totalSum / floatWeight).toFixed(2);
      }
    } else if (floatPrice > 0 && floatWeight > 0) {
      paidAmount.value = (floatPrice * floatWeight).toFixed(2);
    } else if (floatPrice > 0 && totalSum > 0) {
      totalWeight.value = (totalSum / floatPrice).toFixed(4);
    } else if(floatWeight > 0 && totalSum > 0) {
      productPrice.value = (totalSum / floatWeight).toFixed(2);
    }
    if(paidAmountWithoutComm) {
      paidAmountWithoutComm.value = (paidAmount.value * 100 / (100 + freezeNnnPlusPercent)).toFixed(2);
    }
  }

  scrollToTop() {
    let container = $(".wrapper.full").length ? $(".wrapper.full") : $([document.documentElement, document.body]);
    container.scrollTop(0);
  }

  invalidInputs() {
    const invalidFields = [];
    let paidAmount = document.getElementById("bank_total_paid");
    if (paidAmount === null) {
      paidAmount = "";
    } else {
      paidAmount = paidAmount.innerHTML;
    }
    let anotherCheck = document.getElementById("bank_transactions");
    if (anotherCheck === null) {
      anotherCheck = "";
    } else {
      anotherCheck = anotherCheck.classList.contains("d-none");
    }
    const checkLine = "Gesamtbetrag der gezahlten Summe: 0";
    document.querySelectorAll("input.required, input[id=\"cash_payment_total_weight\"], input[id=\"cash_payment_paid_amount\"]").forEach(function (item) {
      if ((paidAmount === checkLine && !anotherCheck) || (item.offsetParent !== null && (item.value.trim() === "" || item.value === "0.0" || item.value === "0") || item.type === "checkbox" && item.checked === false && item.nextSibling && item.nextSibling.offsetParent !== null)) {
        item.classList.add("is-invalid");
        invalidFields.push(item);
      } else {
        item.classList.remove("is-invalid");
      }
    });
    return invalidFields.length;
  }
  
  async updatePdfCashPayment(e) {
    e.preventDefault();
    
    const spinner = document.getElementById("checkbox-loader");
    spinner.classList.remove("d-none");
    
    const checkbox = e.target;
    const cashPaymentId = checkbox.getAttribute("data-id");
    const fieldName = checkbox.getAttribute("data-field");
    const link = `${cashPaymentId}/update_cash_${fieldName}`;
    
    const data = new FormData();
    data.append(`cash_payment[${fieldName}]`, checkbox.checked);
    
    Rails.ajax({
      type: "post",
      url: link,
      data
    });
  }
}
